import { Injectable } from '@angular/core';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { DostavnicaService } from '../pages/dostavnica/dostavnica.service';
import { AuthService } from '../shared/services';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Injectable({
  providedIn: 'root',
})
export class PdfZaDostavniceService {
  constructor(private service: DostavnicaService, private authService: AuthService) {}

  //IZRDA PDF-a DOSTAVNICE
  pdfDostavnica(data) {
    //console.log(data);

    let hLine = {
      table: {
        widths: ['*'],
        body: [[''], ['']],
      },
      layout: {
        hLineWidth: function (i, node) {
          return i === 0 || i === node.table.body.length ? 0 : 1;
        },
        vLineWidth: function (i, node) {
          return 0;
        },
      },
    };

    this.service.dohvatiJednuDostavnicu({ pz_id: data.data.pz_id }).subscribe((res) => {
      //console.log(res);
      if (data.data.DV_NAZIV == 'Dostavnica') {
        if (res.success === true) {
          let ssccPostoji = false;
          for (let stavka of res.data) {
            if (stavka.sscc_broj !== null) {
              ssccPostoji = true;
              break;
            }
          }

          let puna_adresa = '';
          if (res.data[0].pp_puna_adresa) {
            puna_adresa = res.data[0].pp_puna_adresa;
          }else{
            puna_adresa = res.data[0].pa_puna_adresa;
          }

          let drzava_naziv = '';
          if (data.data.dr_naziv) {
            drzava_naziv = ' - ' + `${data.data.dr_naziv || ''}`
          }

          let ct = [];

          ct.push({
            text: 'PEKAR d.o.o.',
            style: 'title',
          });

          ct.push({
            text: 'Obrtnička ulica 5 \n 32100 Vinkovci',
            style: 'subtitle',
            margin: [0, 0, 0, 15],
          });

          ct.push({
            columns: [
              {
                table: {
                  widths: [200],
                  body: [
                    [
                      {
                        table: {
                          body: [
                            [
                              {
                                text: 'Dostavljeno u:',
                                style: 'details',
                              },
                            ],
                            [
                              {
                                text:
                                  res.data[0].pa_naziv + ' \n ' +
                                  res.data[0].pp_naziv + ' \n',
                                style: 'tableTitle',
                              },
                            ],
                            [
                              {
                                text:
                                puna_adresa + ' \n\n',
                              }
                            ]
                          ],
                        },
                        layout: 'noBorders',
                      },
                    ],
                  ],
                },
              },

              {
                text: `Datum dokumenta: ${moment(data.data.pz_datum).format(
                  'DD.MM.YYYY'
                )}.
                Redni broj šlepera: ${data.data.pz_rednibrojslepera}
                Vrijeme utovora: ${
                  res.data[0].pz_vrijemeutovara
                    ? res.data[0].pz_vrijemeutovara
                    : ''
                }
                Registracijska oznaka: ${data.data.pz_registracijavozila}
                Prijevoznik: ${
                  data.data.prijevoznik ? data.data.prijevoznik : ''
                }
                ${data.data.crossdock_naziv || ''}
                ${data.data.crossdock_adresa || ''}
                ${data.data.crossdock_posta || ''}` + ' ' + `${data.data.crossdock_mjesto || ''}
                ${data.data.crossdock_dr_sifra || ''}` +  drzava_naziv,
                style: 'details_2',
              },
            ],
          });

          ct.push({
            text: 'Dostavnica: ' + data.data.pz_broj,
            style: 'mainTitle',
            alignment: 'center',
            margin: [0, 30, 0, 30],
          });

          let brojac = 1;
          let ukupnaKolicina = 0;
          let ukupnoKartona = 0;
          let ukupnoPaleta = res.data.length;
          let arr = res.data;
          let result = arr.reduce(function (r, a) {
            r[a.ar_lot] = r[a.ar_lot] || [];
            r[a.ar_lot].push(a);
            return r;
          }, Object.create(null));

          //console.log(ssccPostoji);

          ct.push({
            table: {
              widths: [15, 40, 150, 20, 35, 55, 55, 35, 30],
              body: [
                [
                  'RB',
                  'Šifra',
                  'Naziv artikla',
                  'Jed.',
                  'LOT',
                  'Važi do',
                  'Količina',
                  'Broj kartona',
                  'Broj paleta',
                ],
              ],
            },
            layout: 'lightHorizontalLines',
          });

          ct.push(hLine);
          for (let lot in result) {
            let stavkaSifra = '';
            let stavkaNaziv = '';
            let stavkaJedMjere = '';
            let stavkaLot = '';
            let stavkaDatum = '';
            let stavkaKolicina = 0;
            let stavkaKartona = 0;
            let brojPaleta = 0;
            for (let stavka of result[lot]) {
              ukupnaKolicina += stavka.pr_izlaz;
              ukupnoKartona += stavka.br_kutija;
              stavkaSifra = stavka.ar_sifra;
              stavkaNaziv = stavka.ar_naziv;
              stavkaJedMjere = stavka.jedinicamjere_JM_SIFRA;
              stavkaLot = stavka.ar_lot;
              //stavkaDatum = stavka.lp_vazido ? moment(stavka.lp_vazido).format('DD.MM.YYYY.') : '';
              stavkaDatum = stavka.lp_vazido != null ? moment(stavka.lp_vazido).format('DD.MM.YYYY.') : moment(stavka.vazi_do_rnalog).format('DD.MM.YYYY.');
              stavkaKolicina += stavka.pr_izlaz;
              stavkaKartona += stavka.br_kutija;
              brojPaleta = result[lot].length;
            }

            ct.push({
              table: {
                widths: [15, 40, 150, 20, 35, 55, 55, 35, 30],
                body: [
                  [
                    brojac++,
                    stavkaSifra,
                    stavkaNaziv,
                    stavkaJedMjere,
                    stavkaLot,
                    stavkaDatum,
                    this.formatiraj(stavkaKolicina, 2),
                    this.formatiraj(stavkaKartona, 2),
                    this.formatiraj(brojPaleta, 2),
                  ],
                ],
              },
              layout: 'lightHorizontalLines',
            });
          }

          ct.push(hLine);
          ct.push({
            table: {
              widths: [402, 63, 45, 25],
              body: [
                [
                  {
                    text: 'UKUPNO',
                    style: 'tableFooter',
                    margin: [30, 0, 0, 0],
                  },
                  { text: this.formatiraj(ukupnaKolicina, 2), style: 'tableFooter' },
                  { text: this.formatiraj(ukupnoKartona, 2), style: 'tableFooter' },
                  { text: this.formatiraj(ukupnoPaleta, 2), style: 'tableFooter' },
                ],
              ],
            },
            layout: 'noBorders',
          });

          let signatureLine = {
            table: {
              widths: ['100%'],
              body: [[''], ['']],
            },
            layout: {
              hLineWidth: function (i, node) {
                return i === 0 || i === node.table.body.length ? 0 : 1;
              },
              vLineWidth: function (i, node) {
                return 0;
              },
            },
          };

          ct.push({
            columns: [
              [
                {
                  text: 'Potpis i pečat skladištara:',
                  margin: [0, 60, 0, 30],
                },
                signatureLine,
              ],
              [],
              [],
              [
                {
                  text: 'Potpis i pečat vozača:',
                  alignment: 'right',
                  margin: [0, 60, 0, 30],
                },
                signatureLine,
              ],
            ],
          });

          var dd = {
            info: {
              title: 'Dostavnica: ' + data.data.pz_id,
            },
            content: ct,
            pageMargins: 20,
            defaultStyle: {
              fontSize: 9.5,
            },
            styles: {
              title: {
                fontSize: 15,
                bold: true,
              },
              subtitle: {
                fontSize: 12,
              },
              details: {
                fontSize: 11,
              },
              details_2: {
                fontSize: 10,
              },
              tableTitle: {
                fontSize: 13,
                bold: true,
              },
              mainTitle: {
                fontSize: 17,
                bold: true,
              },
              tableFooter: {
                bold: true,
              },
            },
          };

          pdfMake.createPdf(dd).open();
        } else {
          notify('Došlo je do pogreške pri dohvaćanju podataka. Pokušajte ponovno!', 'warning', 3000);
        }
      } else {
      }
    });
  }

  pdfDostavnica_ENG(data) {
    //console.log(data);

    let hLine = {
      table: {
        widths: ['*'],
        body: [[''], ['']],
      },
      layout: {
        hLineWidth: function (i, node) {
          return i === 0 || i === node.table.body.length ? 0 : 1;
        },
        vLineWidth: function (i, node) {
          return 0;
        },
      },
    };

    this.service.dohvatiJednuDostavnicu({ pz_id: data.data.pz_id }).subscribe((res) => {
      //console.log(res);
      if (data.data.DV_NAZIV == 'Dostavnica') {
        if (res.success === true) {
          let ssccPostoji = false;
          for (let stavka of res.data) {
            if (stavka.sscc_broj !== null) {
              ssccPostoji = true;
              break;
            }
          }

          let puna_adresa = '';
          if (res.data[0].pp_puna_adresa) {
            puna_adresa = res.data[0].pp_puna_adresa;
          }else{
            puna_adresa = res.data[0].pa_puna_adresa;
          }

          let drzava_naziv = '';
          if (data.data.dr_naziv) {
            drzava_naziv = ' - ' + `${data.data.dr_naziv || ''}`
          }

          let ct = [];

          ct.push({
            text: 'PEKAR d.o.o.',
            style: 'title',
          });

          ct.push({
            text: 'Obrtnička ulica 5 \n 32100 Vinkovci',
            style: 'subtitle',
            margin: [0, 0, 0, 15],
          });

          ct.push({
            columns: [
              {
                table: {
                  widths: [200],
                  body: [
                    [
                      {
                        table: {
                          body: [
                            [
                              {
                                text: 'Delivery:',
                                style: 'details',
                              },
                            ],
                            [
                              {
                                text:
                                  res.data[0].pa_naziv + ' \n ' +
                                  res.data[0].pp_naziv + ' \n',
                                style: 'tableTitle',
                              },
                            ],
                            [
                              {
                                text:
                                puna_adresa + ' \n\n',
                              }
                            ]
                          ],
                        },
                        layout: 'noBorders',
                      },
                    ],
                  ],
                },
              },

              {
                text: `Date of document: ${moment(data.data.pz_datum).format(
                  'DD.MM.YYYY'
                )}.
                Ordinar number truck: ${data.data.pz_rednibrojslepera}
                Loading time: ${
                  res.data[0].pz_vrijemeutovara
                    ? res.data[0].pz_vrijemeutovara
                    : ''
                }
                Registration mark: ${data.data.pz_registracijavozila}
                Carrier: ${
                  data.data.prijevoznik ? data.data.prijevoznik : ''
                }
                ${data.data.crossdock_naziv || ''}
                ${data.data.crossdock_adresa || ''}
                ${data.data.crossdock_posta || ''}` + ' ' + `${data.data.crossdock_mjesto || ''}
                ${data.data.crossdock_dr_sifra || ''}` +  drzava_naziv,
                style: 'details_2',
              },
            ],
          });

          ct.push({
            text: 'Delivery Note: ' + data.data.pz_broj,
            style: 'mainTitle',
            alignment: 'center',
            margin: [0, 30, 0, 30],
          });

          let brojac = 1;
          let ukupnaKolicina = 0;
          let ukupnoKartona = 0;
          let ukupnoPaleta = res.data.length;
          let arr = res.data;
          let result = arr.reduce(function (r, a) {
            r[a.ar_lot] = r[a.ar_lot] || [];
            r[a.ar_lot].push(a);
            return r;
          }, Object.create(null));

          //console.log(ssccPostoji);

          ct.push({
            table: {
              widths: [16, 40, 145, 35, 55, 22, 50, 35, 32],
              body: [
                [
                  'NO.',
                  'Code',
                  'Product',
                  'LOT',
                  'Validuntil',
                  'Measure',
                  'Amount',
                  'Cartons',
                  'Number of pallets',
                ],
              ],
            },
            layout: 'lightHorizontalLines',
          });

          ct.push(hLine);
          for (let lot in result) {
            let stavkaSifra = '';
            let stavkaNaziv = '';
            let stavkaJedMjere = '';
            let stavkaLot = '';
            let stavkaDatum = '';
            let stavkaKolicina = 0;
            let stavkaKartona = 0;
            let brojPaleta = 0;
            for (let stavka of result[lot]) {
              ukupnaKolicina += stavka.pr_izlaz;
              ukupnoKartona += stavka.br_kutija;
              stavkaSifra = stavka.ar_sifra;
              stavkaNaziv = stavka.ar_naziv;
              stavkaJedMjere = stavka.jedinicamjere_JM_SIFRA;
              stavkaLot = stavka.ar_lot;
              //stavkaDatum = stavka.lp_vazido ? moment(stavka.lp_vazido).format('DD.MM.YYYY.') : '';
              stavkaDatum = stavka.lp_vazido != null ? moment(stavka.lp_vazido).format('DD.MM.YYYY.') : moment(stavka.vazi_do_rnalog).format('DD.MM.YYYY.');
              stavkaKolicina += stavka.pr_izlaz;
              stavkaKartona += stavka.br_kutija;
              brojPaleta = result[lot].length;
            }

            ct.push({
              table: {
                widths: [15, 40, 145, 35, 55, 22, 50, 35, 32],
                body: [
                  [
                    brojac++,
                    stavkaSifra,
                    stavkaNaziv,
                    stavkaLot,
                    stavkaDatum,
                    stavkaJedMjere,
                    this.formatiraj(stavkaKolicina, 2),
                    this.formatiraj(stavkaKartona, 2),
                    this.formatiraj(brojPaleta, 2),
                  ],
                ],
              },
              layout: 'lightHorizontalLines',
            });
          }

          ct.push(hLine);
          ct.push({
            table: {
              widths: [402, 63, 45, 25],
              body: [
                [
                  {
                    text: 'IN TOTAL',
                    style: 'tableFooter',
                    margin: [30, 0, 0, 0],
                  },
                  { text: this.formatiraj(ukupnaKolicina, 2), style: 'tableFooter' },
                  { text: this.formatiraj(ukupnoKartona, 2), style: 'tableFooter' },
                  { text: this.formatiraj(ukupnoPaleta, 2), style: 'tableFooter' },
                ],
              ],
            },
            layout: 'noBorders',
          });

          let signatureLine = {
            table: {
              widths: ['100%'],
              body: [[''], ['']],
            },
            layout: {
              hLineWidth: function (i, node) {
                return i === 0 || i === node.table.body.length ? 0 : 1;
              },
              vLineWidth: function (i, node) {
                return 0;
              },
            },
          };

          ct.push({
            columns: [
              [
                {
                  text: 'Signature and stamp storekeeper:',
                  margin: [0, 60, 0, 30],
                },
                signatureLine,
              ],
              [],
              [],
              [
                {
                  text: 'Signature and stamp driver:',
                  alignment: 'right',
                  margin: [0, 60, 0, 30],
                },
                signatureLine,
              ],
            ],
          });

          var dd = {
            info: {
              title: 'Delivery Note: ' + data.data.pz_id,
            },
            content: ct,
            pageMargins: 20,
            defaultStyle: {
              fontSize: 9.5,
            },
            styles: {
              title: {
                fontSize: 15,
                bold: true,
              },
              subtitle: {
                fontSize: 12,
              },
              details: {
                fontSize: 11,
              },
              details_2: {
                fontSize: 10,
              },
              tableTitle: {
                fontSize: 13,
                bold: true,
              },
              mainTitle: {
                fontSize: 17,
                bold: true,
              },
              tableFooter: {
                bold: true,
              },
            },
          };

          pdfMake.createPdf(dd).open();
        } else {
          notify('Došlo je do pogreške pri dohvaćanju podataka. Pokušajte ponovno!', 'warning', 3000);
        }
      } else {
      }
    });
  }

  formatiraj(broj: any, dec_mj: any){
    return this.authService.formatiraj(broj, dec_mj);
  }
}
